import { getPayments } from './jms-payments.js';
import { getInitials } from './string-utils.js';
import { saveAs } from 'file-saver';

let viewCapAcctIconLarge;
let viewCapAcctIconSmall;
let viewTransactionsModal;

export function buildAccountSummary(clientData, userData, isMAR, addedAccountSummaryListenersAlready) {
	/* This generates a pdf for all class cards: uses Regex to strip out and replace unwanted html */
	viewCapAcctIconLarge = document.getElementById('viewCapAcctIconLarge');
	viewCapAcctIconSmall = document.getElementById('viewCapAcctIconSmall');
	viewTransactionsModal = document.getElementById('viewTransactionsModal');

	// Check if account summary is explicitly enabled via flag
	const accountSummaryEnabled = clientData.flags?.show_account_summary === true;

	if (accountSummaryEnabled || !clientData.flags?.enable_dashboard) {
		viewCapAcctIconLarge.classList.remove('hidden');
		viewCapAcctIconSmall.classList.remove('hidden');
		viewCapAcctIconLarge.title = 'Account Summary';
		viewCapAcctIconSmall.title = 'Account Summary';
		document.getElementById('viewCapAcctTriggerLarge').classList.remove('modal-trigger');
		document.getElementById('viewCapAcctTriggerSmall').classList.remove('modal-trigger');
	}

	if (!addedAccountSummaryListenersAlready) {
		addedAccountSummaryListenersAlready = true;
		narrow = screen.width < 600;
		if (narrow) viewCapAcctIconSmall.addEventListener('click', (e) => renderPrintableSummary(clientData, userData, isMAR));
		else viewCapAcctIconLarge.addEventListener('click', (e) => renderPrintableSummary(clientData, userData, isMAR));
	}
}

function renderPrintableSummary(clientData, userData, isMAR) {
	// if (window.analytics) window.analytics.track('View Account Summary Button Clicked', {
	// 	userEmail: authedUser,
	// 	workspace: client
	// }); <--uncomment this if we want to track this

	M.Modal.getInstance(document.getElementById('statementWaitState')).open();
	let content = document.getElementById('shareClassDetails').innerHTML;
	content = content.replace(/ border-blue-2 active/gi, '');

	let cards = content.split('<div class="share-card');
	let classCard = {};
	let sortOrder = [];

	Object.keys(cards).forEach(function (c) {
		cards[c] = '<div class="share-card' + cards[c];
		cards[c] = cards[c].replace(/<span [\s\S]{5,50}?>Selected[\s\S]{0,10}?<\/span>/gi, '');
		cards[c] = cards[c].replace(/<p [\s\S]{10,100}?>Select[\s\S]{1,10}?<\/p>/gi, '');
		cards[c] = cards[c].replace(/<\/h5>[\s\S]{1,100}?<h5 .{5,50}?>/gi, ' - ');
		cards[c] = cards[c].replace(/<h5 /gi, '<h5 style="font-size: 18px; margin-top: 1rem; margin-bottom: 1rem;" ');
		cards[c] = cards[c].replace(/<hr /gi, '<hr style="margin-bottom: 1rem" ');
		cards[c] = cards[c].replace(/ class="text-secondary/gi, ' style="line-height: 1.8;" class="text-secondary');
		cards[c] = cards[c].replace(/<p .+?>Show schedule<\/a><\/p>/gi, '');
		cards[c] = cards[c].replace(/<div .+?>Vesting Schedule<\/div>/gi, '');
		let match = cards[c].match(/data-class="(.{1,20}?)"/i);

		if (match && isMAR) {
			classCard[match[2]] = cards[c];
			sortOrder.push(match[2]);
		} else if (match) {
			classCard[match[1]] = cards[c];
			sortOrder.push(match[1]);
		}
	});
	let cardKeys = Object.keys(classCard);
	cardKeys.sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b));

	let valueHeading = document.getElementById('valueHeading');
	let viewCapAcctModal = document.getElementById('viewCapAcctModal');
	let dateNow = moment().format('MMM D, YYYY');
	let userName = userData.user_name.replace(/_/g, ' ');

	viewCapAcctModal.innerHTML = `
        <div id="accountSummary" style="font-family: 'Source Sans Pro', sans-serif; font-size: 18px; padding: 2rem">
            <img id="brandLogo" class="responsive-img" src="${clientData.company_logo ? formatImg(clientData.company_logo, '/h_48/') : ''}">
            <div class="row mb-0">
                <div class="s12 justify-between flex items-center">
                    <h2 class="text-2xl font-bold mt-0 mb-0" style="min-width: 800px;">Account Summary <span style="font-weight: lighter; color: gray">as of ${dateNow}</span></h2>
                </div>
            </div>
            <div class="row mt-0">
                <div id="accountDetails" class="col s12 text-secondary" style="font-weight: lighter; color: gray">${userName + ' - ' + userData.userid}</div>
            </div>
            <div class="row" style="display: block; margin-top: 1rem;">${valueHeading.innerHTML}</div>
            <div>
                <div class="row">
                    <table id="userStatementsSortTable" class="highlight table-content responsive-table" style="table-layout:fixed; width: 100%;">
                        <tbody>
                        ${cardKeys
							.map(
								(key, index) =>
									`
                            <tr>
                                <td width='60%'>
                                    <div style="page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%; background: #FFFFFF; border:1px solid #E1E1E1; border-radius: 4px; padding: 1rem; margin-top: 2.5rem; padding-bottom: 1.5rem;">${classCard[key]}</div>
                                </td width='40%'>
                                <td style="vertical-align: top;">
                                    <div style="page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%;"">
                                        <img src=${clientData.equity[key] && clientData.equity[key].landingPage && clientData.equity[key].landingPage.image ? clientData.equity[key].landingPage.image.replace(/\/image\/upload\//i, '\/image\/upload\/w_200\/') : clientData.product_image.replace(/\/image\/upload\//i, '\/image\/upload\/w_200\/')} class="responsive-img mt-2" style="width: 10rem; height: 8rem; object-fit: cover; cursor: default; display: block; margin-top: 3rem; margin-left: 8rem; margin-right: auto;">
                                    </div>
                                </td>
                            </tr>
                            `
							)
							.join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;

	let Api2Pdf = require('api2pdf');
	let a2pClient = new Api2Pdf('6e053f8e-75b7-4271-a316-1981d7640681');
	let fileName = 'Account Summary for ' + userName + ' as of ' + moment().format('MM-D-YYYY') + '.pdf';
	a2pClient
		.chromeHtmlToPdf(viewCapAcctModal.innerHTML, { inline: false, filename: fileName })
		.then(function (result) {
			console.log(result);
			let request = new XMLHttpRequest();
			request.open('GET', result.FileUrl, true);
			request.responseType = 'blob';
			request.onload = function () {
				saveAs(result.FileUrl, fileName);
				M.Modal.getInstance(document.getElementById('statementWaitState')).close();
			};
			request.send();
		})
		.catch(function (err) {
			// #6445: api2pdf rejects with its response object (e.g. Invalid API key).
			console.error('Account summary PDF failed:', err?.Error || err);
			M.Modal.getInstance(document.getElementById('statementWaitState'))?.close();
			window.showToast?.('error-toast', 'Sorry, the PDF could not be generated. Please try again later.');
		});
}

export async function generateAmortizationSchedule(nrid, transactions, opts = {}) {
	const mode = opts.mode || 'html';

	let thisTrans = transactions.find((t) => t.nrid == nrid);
	// console.log(thisTrans);

	let amorTable;
	let now = Date.now() / 1000;
	let start = thisTrans.date;
	let qty = Number(thisTrans.quantity);
	let pv = Number(thisTrans.sharePrice);
	let gross = Number(thisTrans.referencePrice);
	let its2022 = moment.unix(start).year() == 2022;
	let its2025 = moment.unix(start).year() == 2025;

	if (isBOH) {
		const loanMatch = thisTrans.notes.match(/\(\s*(NP|NR)(?:-([a-zA-Z0-9]+))?[^$0-9]*\$?([\d,\.]+)/);
		if (!loanMatch) {
			amorTable = `<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1">No data to display.</div>`;
		} else {
			// 🔹 AFR rate helper — AFR in effect ON the given date (keys in clientData.interest_rates)
			function getAFRRateFromClientData(dateLike) {
				const m = moment(dateLike);
				const rates = Object.entries(clientData.interest_rates || {})
					.map(([effective, rate]) => ({ effective, rate: Number(rate) / 100 }))
					.sort((a, b) => moment(b.effective).diff(moment(a.effective)));
				const found = rates.find((r) => m.isSameOrAfter(moment(r.effective, 'YYYY-MM-DD'), 'day'));
				const rate = found ? found.rate : rates.length ? rates[rates.length - 1].rate : 0.0568;
				return Math.round(rate * 10000) / 10000; // round to 4dp to avoid float tails
			}

			// 🔹 Shared helper: build paymentDates array (reuses your legacy vs synthesize behavior)
			function buildPaymentDates({ pattern, numPayments, startDate, payments }) {
				function parseDateLocal(dateStr) {
					const [year, month, day] = dateStr.split('-').map(Number);
					return new Date(year, month - 1, day); // JS months are 0-based
				}
				// Only count legacy dates that are actually on/after this loan's start date
				let legacyDates = Object.keys(payments)
					.map(parseDateLocal)
					.filter((d) => d >= startDate)
					.sort((a, b) => a - b);

				let futureDates = [];

				// Only synthesize future dates if needed
				let paymentDates;
				if (legacyDates.length >= numPayments) {
					paymentDates = legacyDates.slice(0, numPayments);
				} else {
					let pDate = new Date(2025, 3, 15); // Apr 15, 2025
					for (let i = 0; futureDates.length + legacyDates.length < numPayments && i < 40; i++) {
						const clone = new Date(pDate.getTime());
						const dateISO = clone.toISOString().slice(0, 10);
						if (clone >= startDate && !payments[dateISO]) futureDates.push(clone);
						pDate.setMonth(pDate.getMonth() + 6);
					}
					paymentDates = [...legacyDates, ...futureDates]
						.sort((a, b) => a - b) // Sort oldest → newest
						.slice(0, numPayments); // Only keep required payments
				}
				return paymentDates;
			}

			// ---------- Minimal Excel-style ACT/365 helpers ----------
			function daysIncUTC(a, b) {
				// Excel-like inclusive day count: DAYS(end,start)+1
				const Au = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
				const Bu = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
				return Math.max(0, Math.floor((Bu - Au) / 86400000) + 1);
			}
			function firstAfrChangeInside(fromDate, toDate) {
				const entries = Object.entries(clientData.interest_rates || {})
					.map(([d, r]) => new Date(d + 'T00:00:00Z'))
					.sort((a, b) => a - b);
				for (const eff of entries) {
					// strictly inside (fromDate, toDate] to match sheet examples
					if (eff > fromDate && eff <= toDate) return eff;
				}
				return null;
			}

			// Daily simple interest for a single period, ACT/365, with a single AFR split if needed.
			function accrueDailyInterest(balance, fromDate, toDate, { basis = 'ACT/365', isShortSchedule = false } = {}) {
				if (balance <= 0 || !(fromDate instanceof Date) || !(toDate instanceof Date) || toDate < fromDate) return 0;

				// Short schedules: 7.5% ONLY for loans that started before 10/01/2023
				if (isShortSchedule && Number(thisTrans.date) <= 1696118400) {
					// 2023-10-01 00:00:00 UTC
					const denom = basis === 'ACT/365' ? 365 : 360;
					const d = daysIncUTC(fromDate, toDate);
					return Math.round(balance * (0.075 * (d / denom)) * 100) / 100;
				}

				// Excel-style split on AFR effective date if it falls inside the period
				const change = firstAfrChangeInside(fromDate, toDate);
				const denom = basis === 'ACT/365' ? 365 : 360;

				if (change) {
					const denom = basis === 'ACT/365' ? 365 : 360;

					// Old rate THROUGH the change date (inclusive)
					const changeLocal = new Date(change.getUTCFullYear(), change.getUTCMonth(), change.getUTCDate());
					const nextDay = new Date(changeLocal);
					nextDay.setDate(nextDay.getDate() + 1);

					const oldRate = getAFRRateFromClientData(fromDate);
					const newRate = getAFRRateFromClientData(nextDay);

					const d1 = daysIncUTC(fromDate, changeLocal); // inclusive
					const d2 = daysIncUTC(nextDay, toDate); // inclusive

					const val = balance * (oldRate * (d1 / denom) + newRate * (d2 / denom));
					return Math.round(val * 100) / 100;
				} else {
					// single AFR over the whole period; pick rate in effect on period end (matches client sheets)
					const rate = getAFRRateFromClientData(toDate);
					const d = daysIncUTC(fromDate, toDate);
					return Math.round(balance * (rate * (d / denom)) * 100) / 100;
				}
			}

			// 🔹 New flat principal schedule (post-Oct 2025), but STILL honors overrides
			function buildFlatPrincipalSchedule({ loanAmount, numPayments, startDate, paymentDates, payments, isShortSchedule }) {
				const fixedPrincipal = Math.round((loanAmount / numPayments) * 100) / 100;
				let balance = loanAmount;
				let d = new Date(startDate);
				let schedule = [];

				for (let i = 0; i < numPayments; i++) {
					const currentDate = paymentDates[i];
					if (!currentDate) {
						console.error('Missing payment date', { i, paymentDates, startDate, pattern, numPayments });
						break;
					}
					const dateStr = currentDate.toISOString().slice(0, 10);

					// 🔸 Daily interest from previous payment date → current date (ACT/365 default)
					// const periodStart = i === 0 ? new Date(startDate) : new Date(paymentDates[i - 1] || d);
					// NEW CODE 4-14-2026
					let periodStart;
					if (i === 0) {
						// First period: start on the loan date
						periodStart = new Date(startDate);
					} else {
						// Subsequent periods: start the day after the prior payment
						periodStart = new Date(paymentDates[i - 1] || d);
						periodStart.setDate(periodStart.getDate() + 1);
					}

					const periodEnd = currentDate;
					let interest = accrueDailyInterest(balance, periodStart, periodEnd, {
						basis: 'ACT/365', // client prefers ACT/365
						isShortSchedule,
					});

					// default: flat principal
					let thisPrincipal = i === numPayments - 1 ? balance : fixedPrincipal;

					// 🔹 Apply overrides if any (factor | principal)
					if (payments[dateStr]) {
						const parts = payments[dateStr].split('|');
						const factor = parseFloat(parts[0]) || 0;
						const overridePrincipal = parts[1] !== undefined ? Number(parts[1]) : null;

						// If admin supplies a factor, it overrides the computed daily interest
						if (!isNaN(factor) && factor !== 0) {
							interest = Math.round(balance * factor * 100) / 100;
						}

						if (overridePrincipal !== null) {
							thisPrincipal = overridePrincipal;

							// 🔍 Detect skipped principal (explicit 0) and extend schedule
							if (overridePrincipal === 0) {
								numPayments++;
								let nextDate = new Date(currentDate);
								nextDate.setMonth(nextDate.getMonth() + 6);
								paymentDates.push(nextDate);
							}
						}
					}

					const payment = Math.round((thisPrincipal + interest) * 100) / 100;
					balance = Math.round((balance - thisPrincipal) * 100) / 100;

					schedule.push({
						number: i + 1,
						date: new Intl.DateTimeFormat('en-US').format(currentDate),
						stamp: Math.floor(currentDate.getTime() / 1000),
						payment: payment.toFixed(2),
						interest: interest.toFixed(2),
						principal: thisPrincipal.toFixed(2),
						balance: balance.toFixed(2),
					});

					// increment default date if not from paymentDates
					d.setMonth(d.getMonth() + 1);
				}
				return schedule;
			}

			// 🔹 Legacy TValue-style schedule (pre-Oct 2025), now using per-period AFR for non-override rows
			function buildLegacySchedule({ loanAmount, numPayments, startDate, paymentDates, payments, today, isShortSchedule }) {
				let schedule = [];
				let balance = loanAmount;
				let principalPayment = (100 * (loanAmount / numPayments)) / 100; // round to pennies
				let previousDate = startDate;
				let effectiveRate = 0;

				for (let i = 0; i < numPayments; i++) {
					if (balance <= 0) break;
					const currentDate = paymentDates[i];
					const dateStr = currentDate.toISOString().slice(0, 10); // e.g., "2023-10-15"
					let thisPrincipal = principalPayment;
					let interest = 0;

					if (payments[dateStr]) {
						const parts = payments[dateStr].split('|');
						const factor = parseFloat(parts[0]) || 0;
						const overridePrincipal = parts[1] !== undefined ? Number(parts[1]) : null;

						// 🔹 Use stored historical interest factor
						interest = Math.round(balance * factor * 100) / 100;

						if (overridePrincipal !== null) {
							thisPrincipal = overridePrincipal;

							// adjust up principal payment - seems crazy...
							if (i == 0) principalPayment = (100 * ((loanAmount - overridePrincipal) / (numPayments - i - 1))) / 100;

							// 🔍 Detect skipped principal (explicit 0) and extend schedule
							if (overridePrincipal === 0) {
								numPayments++;
								let nextDate = new Date(paymentDates[paymentDates.length - 1]); // last known date
								nextDate.setMonth(nextDate.getMonth() + 6);
								paymentDates.push(nextDate);
							}
						}
					} else {
						// 🔸 Use daily simple interest (ACT/365) by default
						const periodStart =
							i === 0
								? new Date(startDate) // first period starts ON loan date (inclusive)
								: new Date(previousDate.getFullYear(), previousDate.getMonth(), previousDate.getDate() + 1);
						const periodEnd = currentDate;

						// 👉 TValue stub override: first period only for NP/NR starting 1/1/2025, due ~4/14–4/15
						const patternSuffix = loanMatch[2] || null;
						const isPlainNP = loanType === 'NP' && !patternSuffix; // ✅ override
						const isPlainNR = loanType === 'NR' && !patternSuffix; // ✅ override
						const isNR6 = loanType === 'NR' && patternSuffix === '6'; // ✅ override
						const isNR14 = loanType === 'NR' && patternSuffix === '14'; // ✅ override
						const isNP14 = loanType === 'NP' && patternSuffix === '14'; // ❌ NO override

						const isFirstStub = i === 0;
						const isJan1_2025 = startDate.getFullYear() === 2025 && startDate.getMonth() === 0 && startDate.getDate() === 1;
						const isMidApril = currentDate.getMonth() === 3 && (currentDate.getDate() === 14 || currentDate.getDate() === 15);

						if (!isNP14 && (isPlainNP || isPlainNR || isNR6 || isNR14) && isFirstStub && isJan1_2025 && isMidApril) {
							// TValue-style first stub (calibrated)
							const annualRate = getAFRRateFromClientData(startDate); // 0.0568 on 2025-01-01
							const monthsInPeriod = 3.460860526;
							const effectiveRate = Math.pow(1 + annualRate / 12, monthsInPeriod) - 1;
							interest = Math.round(balance * effectiveRate * 100) / 100;
						} else {
							interest = accrueDailyInterest(balance, periodStart, periodEnd, {
								basis: 'ACT/365',
								isShortSchedule,
							});
						}
					}

					let payment = Math.round((interest + thisPrincipal) * 100) / 100;

					// Adjust final payment to force balance to zero
					if (i === numPayments - 1) {
						// Final row: keep the daily interest we already computed for [prev+1 .. current]
						thisPrincipal = balance; // pay off all remaining principal
						payment = Math.round((interest + thisPrincipal) * 100) / 100;
						balance = 0;
					} else {
						// 🔸 Normal balance reduction for fixed principal
						balance = Math.round((balance - thisPrincipal) * 100) / 100;
					}

					schedule.push({
						number: i + 1,
						date: new Intl.DateTimeFormat('en-US').format(currentDate),
						stamp: Math.floor(currentDate.getTime() / 1000),
						payment: payment.toFixed(2),
						interest: interest.toFixed(2),
						principal: thisPrincipal.toFixed(2),
						balance: balance.toFixed(2),
					});

					// Update previous date for next iteration
					previousDate = currentDate;
				}

				return schedule;
			}

			const loanType = loanMatch[1]; // "NP" or "NR"
			const pattern = loanMatch[2] || '6'; // "10dd"
			let numPayments = Number(pattern.replace(/[^.\d]/g, ''));
			const loanAmount = Number(loanMatch[3].replace(/[^.\d]/g, ''));

			// NOTE: daysInYear left for reference; not directly used after refactor
			const daysInYear = 360; // TValue likely uses 360-day year for daily interest
			const compoundingPeriodsPerYear = 12; // Monthly compounding
			const today = new Date();

			const startDate = new Date(start * 1000);
			const isShortSchedule = numPayments <= 6;

			// Build payment dates once (shared by both schedule builders)
			const payments = clientData.payment_patterns[pattern] || {};
			const paymentDates = buildPaymentDates({ pattern, numPayments, startDate, payments });

			// Cutover: loans starting on/after Oct 1, 2025 → flat-principal baseline (still with overrides, now daily interest)
			const cutoffDate = new Date(2025, 9, 1); // October 1, 2025

			let schedule = [];
			if (startDate >= cutoffDate) {
				schedule = buildFlatPrincipalSchedule({
					loanAmount,
					numPayments,
					startDate,
					paymentDates,
					payments,
					isShortSchedule,
				});
			} else {
				schedule = buildLegacySchedule({
					loanAmount,
					numPayments,
					startDate,
					paymentDates,
					payments,
					today,
					isShortSchedule,
				});
			}

			// ⛳ Totals recompute from schedule (paid vs due by "now")
			let totalIntDue = 0,
				totalIntPaid = 0,
				totalPrinDue = 0,
				totalPrinPaid = 0;
			for (const row of schedule) {
				if (row.stamp < now) {
					totalIntPaid += Number(row.interest);
					totalPrinPaid += Number(row.principal);
				} else {
					totalIntDue += Number(row.interest);
					totalPrinDue += Number(row.principal);
				}
			}

			// Accrued interest (payoff) — DAILY from last paid date → today (ACT/365 by default)
			let payoffStartDate = [...paymentDates].reverse().find((date) => date < today) || startDate;
			if (payoffStartDate) {
				payoffStartDate = new Date(payoffStartDate);
				payoffStartDate.setDate(payoffStartDate.getDate() + 1);
			}
			let accruedInterest = accrueDailyInterest(totalPrinDue, payoffStartDate, today, { basis: 'ACT/365', isShortSchedule });
			// If you must keep the historic fudge factor, uncomment next line:
			// accruedInterest = accruedInterest * 0.998311254;

			const payOffAmount = totalPrinDue + Math.round(accruedInterest * 100) / 100;

			// For snapshot: approximate ending balance from schedule (fallback to original loan)
			const endingBalance = schedule.length ? Number(schedule[schedule.length - 1].balance) : loanAmount;

			const entityName = thisTrans.shareClass == 'BMI' ? 'BMI' : 'Bohler ' + thisTrans.shareClass;
			const description = `${qty.toLocaleString()} shares (${(qty / 10).toLocaleString()}% of ${entityName}) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share`;

			if (mode === 'snapshot') {
				// Month window (local) — display-only, not a data-path filter // utc-ok
				const monthStart = moment().startOf('month').startOf('day').unix(); // utc-ok
				const monthEnd = moment().endOf('month').endOf('day').unix(); // utc-ok

				// Prefer a payment IN this month; if none, roll to the first AFTER this month.
				let upcoming = schedule.find((r) => r.stamp >= monthStart && r.stamp <= monthEnd);
				if (!upcoming) upcoming = schedule.find((r) => r.stamp > monthEnd);

				// No upcoming at all → finished or irrelevant → skip from report
				if (!upcoming) return null;

				const currentTotalPayment = Number(upcoming.payment);
				const principalBalanceAfterCurrentPayment = Number(upcoming.balance);
				const finalPaymentDate = paymentDates?.[paymentDates.length - 1] || null;
				const purchaseOrSale = /sale/i.test(thisTrans?.eventType || thisTrans.notes || thisTrans?.description || '') ? 'Sale' : 'Purchase';
				const loanDate = moment.unix(Number(start)).toDate();

				return {
					company: thisTrans.shareClass,
					purchaseOrSale,
					description,
					loanDate,
					originalLoan: loanAmount,
					currentTotalPayment,
					principalBalanceAfterCurrentPayment,
					finalPaymentDate: finalPaymentDate ? new Date(finalPaymentDate) : null,
					loanType,
				};
			}

			function getCurrentRateInfo(refDate = new Date()) {
				const entries = Object.entries(clientData.interest_rates || {})
					.map(([d, r]) => ({ eff: new Date(d + 'T00:00:00Z'), pct: Number(r) })) // pct as e.g. 5.68
					.sort((a, b) => a.eff - b.eff);
				let match = entries.filter((e) => e.eff <= refDate).pop();
				if (!match && entries.length) match = entries[0];
				return match || null; // {eff: Date, pct: 5.68}
			}

			const shortPrime = isShortSchedule && Number(thisTrans.date) <= 1696118400; // pre-2023-10-01
			let currentRateLabel;
			if (shortPrime) {
				currentRateLabel = '7.00% Prime (effective 10/29/2025).'; //" short schedule; ACT/365)";
			} else {
				const ri = getCurrentRateInfo(new Date());
				currentRateLabel = ri
					? `${ri.pct.toFixed(2)}% AFR (effective ${moment(ri.eff).format('M/D/YYYY')}).` // ACT/365)`
					: 'N/A';
			}

			// ---------- Rendering (unchanged structure) ----------
			amorTable = `
                <div>
                    <p class="text-xs mt-0 mb-0">${thisTrans.receiverName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${description}.</p>
                    <p class="text-xs mt-0 mb-0">Amount due if paid off in full today: Principal ${totalPrinDue.toLocaleString('en-US', usd)} + Accrued Interest ${accruedInterest.toLocaleString('en-US', usd)} = <span class="font-bold">${payOffAmount.toLocaleString('en-US', usd)}</span></p>
                    <p class="text-xs mt-0 mb-4">Current interest rate: ${currentRateLabel}</p>
                </div>
                <table id="amortizationSortTable" class="card highlight table-content">
                    <thead>
                        <tr>
                            <th class="text-xs p-05 right-align">#</th>
                            <th class="text-xs p-05 right-align">Date</th>
                            <th class="text-xs p-05 right-align">Payment</th>
                            <th class="text-xs p-05 right-align">Interest</th>
                            <th class="text-xs p-05 right-align">Principal</th>
                            <th class="text-xs p-05 right-align">Balance</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

			amorTable += `
                <tr>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 center-align"><span>Loan</span></p>
                    </td>
                    <td class="text-xs text-secondary p-0">
                        <p class="mb-0 mt-0 right-align"><span>${new Date(Number(start) * 1000).toLocaleDateString('en-US')}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span></span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${loanAmount.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            `;
			schedule.forEach((sched) => {
				amorTable += `
                    <tr>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0" data-sort='${sched.stamp}'>
                            <p class="mb-0 mt-0 center-align"><span>${sched.number}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0" data-sort='${sched.stamp}'>
                            <p class="mb-0 mt-0 right-align"><span>${sched.date}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.payment).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.interest).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.principal).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs ${sched.stamp < now ? 'text-secondary' : ''} p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(sched.balance).toLocaleString('en-US', usd)}</span></p>
                        </td>
                    </tr>
                `;
			});

			amorTable += `
                </tbody>
                <tfoot>
                    <tr>
                        <td class="text-xs text-secondary border-t-2 p-0" colspan="2">
                            <p class="ml-6 mt-0 mb-0 left-align"><span>Amounts Paid Already</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${totalIntPaid.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs text-secondary border-t-2 p-0">
                            <p class="mt-0 mb-0 mr-4 right-align"><span>${totalPrinPaid.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-xs p-0" colspan="2">
                            <p class="ml-6 mb-0 mt-0 left-align"><span>Amounts To Be Paid</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${totalIntDue.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${totalPrinDue.toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-xs font-bold p-0" colspan="2">
                            <p class="ml-6 mb-0 mt-0 left-align"><span>TOTAL</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid + totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalIntPaid + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td class="text-xs font-bold p-0">
                            <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalPrinDue).toLocaleString('en-US', usd)}</span></p>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
                </table>
            `;

			// not used (yet...)
			function getFractionalMonths(start, end) {
				let yearsDiff = end.getFullYear() - start.getFullYear();
				let monthsDiff = end.getMonth() - start.getMonth();
				let totalMonths = yearsDiff * 12 + monthsDiff;

				// Get the number of days in the start month
				let startOfNextMonth = new Date(start.getFullYear(), start.getMonth() + 1, 1);
				let daysInStartMonth = (startOfNextMonth - start) / (1000 * 60 * 60 * 24);

				// Compute fractional month component
				let dayFraction = (end.getDate() - start.getDate()) / daysInStartMonth;

				// Adjust for mid-month start and end cases
				if (start.getDate() > 1 && end.getDate() > 1) {
					dayFraction = (end.getDate() - start.getDate()) / 30; // Approximate 30-day months
				}

				return totalMonths + dayFraction;
			}
		}
	} else {
		// JM Search
		let finance = new Finance();
		let pmt = gross / 40;
		let rate = finance.RATE(40, -pmt, pv);
		console.log('Annual Rate: ' + rate * 400);
		let amort = {};
		let balance = pv * qty;
		let totalIntDue = 0;
		let totalPrinDue = 0;
		let totalIntPaid = 0;
		let totalPrinPaid = 0;
		let scheduledPmt = -finance.PMT(0.0181 / 4, 40, pv) * qty;
		console.log('Sceduled Payment: ' + scheduledPmt);

		let eventUserData;
		if (pn.includes('/admin/users/edit')) eventUserData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
		else eventUserData = JSON.parse(sessionStorage.getItem('user.Data'));

		for (let i = 1; i <= 40; i++) {
			let date = moment.unix(start).add(3 * i, 'months');
			let dateString = date.format('MMM-YY');
			let timeStamp = Date.parse(date) / 1000;
			let ppmt = -finance.PPMT(rate, i, 40, pv) * qty;
			let ipmt = -finance.IPMT(rate, i, 40, pv) * qty;
			// handle non-standard 2022 amortization
			if (its2022) {
				ipmt = (balance * 0.0181) / 4;
				ppmt = scheduledPmt - ipmt;
				// this feels incorrect as it skips the last interest payment
				if (scheduledPmt >= balance) {
					ppmt = balance;
					ipmt = 0;
				}
				balance -= ppmt;
			}
			let ttl = ppmt + ipmt;
			if (date > moment()) {
				totalIntDue += ipmt;
				totalPrinDue += ppmt;
			} else {
				totalIntPaid += ipmt;
				totalPrinPaid += ppmt;
			}
			amort[i] = { number: i, stamp: timeStamp, date: dateString, total: ttl, principal: ppmt, interest: ipmt };
		}
		// console.log(amort);

		amorTable = `
            <div>
                ${
					thisTrans.sender == eventUserData.userid
						? `
                    <p class="text-xs mt-0 mb-0">Sold to ${thisTrans.receiverName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${qty.toLocaleString()} shares (${qty / 10000}% of JMS) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share.</p>
                `
						: `
                    <p class="text-xs mt-0 mb-0">Purchased from ${thisTrans.senderName}, January ${moment.unix(start).format('YYYY')}:&nbsp;${qty.toLocaleString()} shares (${qty / 10000}% of JMS) at ${Number(thisTrans.sharePrice).toLocaleString('en-US', { style: 'currency', currency: 'USD' })} per share.</p>
                `
				}
                ${
					its2022
						? `
                    <p class="text-xs mt-0">Assuming 39 equal payments and one final payment over 10 years, interest rate = 1.81%<p>
                `
						: `
                    <p class="text-xs mt-0">Assuming 40 equal payments over 10 years, implied compound annual interest rate = ${(rate * 400).toLocaleString('en-US', m4)}%<p>
                `
				}
            </div>
            <table id="amortizationSortTable" class="card highlight table-content">
                <thead>
                    <tr>
                        <th class="text-xs p-05 right-align">&emsp;#&emsp;&emsp;Payment</th>
                        <th class="text-xs p-05 right-align">Amount</th>
                        <th class="text-xs p-05 right-align">Principal</th>
                        <th class="text-xs p-05 right-align">Interest</th>
                    </tr>
                </thead>
                <tbody>
            `;
		Object.keys(amort).forEach((a) => {
			amorTable += `
                <tr>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0" data-sort='${amort[a].stamp}' style="width:25%">
                        <p class="mb-0 mt-0 center-align"><span>${amort[a].number}&ensp;&ensp;<span class="text-white">|</span>&ensp;&ensp;${amort[a].date}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].total).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].principal).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs ${amort[a].stamp < now ? 'text-secondary' : ''} p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${Number(amort[a].interest).toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            `;
		});

		amorTable += `
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="ml-6 mt-0 mb-0 left-align"><span>Amounts Paid Already</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${totalPrinPaid.toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs text-secondary border-t-2 p-0">
                        <p class="mt-0 mb-0 mr-4 right-align"><span>${totalIntPaid.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
                <tr>
                    <td class="text-xs p-0">
                        <p class="ml-6 mb-0 mt-0 left-align"><span>Amounts To Be Paid</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${totalPrinDue.toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${totalIntDue.toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
                <tr>
                    <td class="text-xs font-bold p-0">
                        <p class="ml-6 mb-0 mt-0 left-align"><span>TOTAL</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalIntPaid + totalPrinDue + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalPrinPaid + totalPrinDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                    <td class="text-xs font-bold p-0">
                        <p class="mb-0 mt-0 mr-4 right-align"><span>${(totalIntPaid + totalIntDue).toLocaleString('en-US', usd)}</span></p>
                    </td>
                </tr>
            </tfoot>
            </table>
        `;
	}

	document.getElementById('amortizationTable').innerHTML = amorTable;
	let table = document.getElementById('amortizationSortTable');
	if (table) {
		let sort = new Tablesort(table, { descending: false });
	}

	let amortizationModal = document.getElementById('amortizationModal');
	// M.Modal.getInstance(amortizationModal).options.dismissible = false;
	// M.Modal.getInstance(viewTransactionsModal).close();
	if (!viewTransactionsModal) viewTransactionsModal = document.getElementById('viewTransactionsModal');
	if (viewTransactionsModal) viewTransactionsModal.classList.add('hidden');
	M.Modal.getInstance(amortizationModal).open();
	amortizationModal.scrollTo(0, scroll);
	document.getElementById('closeAmortization').addEventListener('click', function (e) {
		M.Modal.getInstance(amortizationModal).close();
		if (viewTransactionsModal) viewTransactionsModal.classList.remove('hidden');
	});
	if (window.analytics)
		window.analytics.track('Viewed Amortization', {
			userEmail: authedUser,
			workspace: client,
			userId: userData.userid,
		});
}

export async function generateLoansReport(transactions, adminReport = false) {
	const headers = ['Company', 'Purchase or Sale', 'Description', 'Loan Date', 'Original Loan', 'Current Payment', 'Principal Balance', 'Final Payment Date'];

	// CSV escape (keep only for CSV fallbacks, NOT for HTML tables)
	const esc = (v) => {
		if (v === null || v === undefined) return '';
		const s = String(v);
		return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
	};
	// HTML escape (for DOM tables → Excel). Do NOT add quotes.
	const html = (v) => {
		if (v === null || v === undefined) return '';
		const s = String(v);
		return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	};

	const fmtDate = (d) => (d instanceof Date && !isNaN(d) ? moment(d).format('MM/DD/YYYY') : '');
	const fmtNum = (n) => (n === null || n === undefined || isNaN(n) ? '' : Number(n).toLocaleString('en-US', m2));

	// Filter "loan-ish" transactions (your original regex)
	const loans = (transactions || []).filter((t) => /\(\s*(NP|NR)(-\d+)?[^)]*\)/.test(t.notes || ''));

	// Sort (newest first; if you also want by size, do that before)
	loans.sort((a, b) => Number(b.date) - Number(a.date));

	// Build rows into two buckets
	const rowsNP = []; // Notes Payable
	const rowsNR = []; // Notes Receivable

	for (const t of loans) {
		const s = await generateAmortizationSchedule(t.nrid, loans, { mode: 'snapshot' });
		if (!s) continue;

		// NOTE: For HTML tables we do NOT CSV-escape. We format, then HTML-escape in the renderer.
		const rowRaw = [
			s.company,
			s.loanType == 'NP' ? 'Purchase' : 'Sale',
			s.description,
			fmtDate(s.loanDate),
			fmtNum(s.originalLoan),
			fmtNum(s.currentTotalPayment),
			fmtNum(s.principalBalanceAfterCurrentPayment),
			fmtDate(s.finalPaymentDate),
		];
		const type = s && s.loanType ? s.loanType : (t.notes || '').match(/\(\s*(NP|NR)/)?.[1] || 'NP';

		if (type === 'NR') rowsNR.push(rowRaw);
		else rowsNP.push(rowRaw);
	}

	// Admin report: return both buckets (no headers)
	if (adminReport) {
		return { NP: rowsNP, NR: rowsNR };
	}

	// ---------- HTML tables for your exporter ----------
	function buildHtmlTable(id, title, hdrs, rows) {
		const thead = `<thead><tr>${hdrs.map((h) => `<th class="text-xs p-05 right-align">${html(h)}</th>`).join('')}</tr></thead>`;
		const tbody = `<tbody>${rows.map((r) => `<tr>${r.map((c) => `<td class="text-xs p-0">${html(c)}</td>`).join('')}</tr>`).join('')}</tbody>`;
		return `
            <h4 style="margin:8px 0">${html(title)}</h4>
            <table id="${id}" class="card highlight table-content" aria-label="${html(title)}">
                ${thead}
                ${tbody}
            </table>
        `;
	}

	const hasNP = rowsNP.length > 0;
	const hasNR = rowsNR.length > 0;

	let userName = userData.user_name;
	if (pn.includes('/users/edit')) {
		if (!shareholderData) shareholderData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
		userName = shareholderData.user_name;
	}
	const dateTag = moment().format('YYYY-MM-DD');
	const outFile = `${userName} Loans Summary dated ${dateTag}.csv`; // match your example’s extension

	// 🚦 Nothing to export? Alert and bail.
	if (!hasNP && !hasNR) {
		alert('No current Notes Payable or Notes Receivable payments to export.');
		return;
	}

	// Build one hidden container with up to two tables
	const containerId = 'loan-report-export';
	let container = document.getElementById(containerId);
	if (!container) {
		container = document.createElement('div');
		container.id = containerId;
		container.style.display = 'none';
		document.body.appendChild(container);
	}

	// Assign fixed IDs that we’ll pass to export_table_to_excel
	const npId = 'notesPayableTable';
	const nrId = 'notesReceivableTable';

	container.innerHTML = `
        ${hasNP ? buildHtmlTable(npId, 'Notes Payable', headers, rowsNP) : ''}
        ${hasNR ? buildHtmlTable(nrId, 'Notes Receivable', headers, rowsNR) : ''}
    `;

	// Build the pipe-separated id list (only include tables that exist)
	const idList = [hasNP ? npId : null, hasNR ? nrId : null].filter(Boolean).join('|');

	// 🔸 Call your exporter EXACTLY as required
	export_table_to_excel(idList, outFile);
}

// Payment Statement for JM Search's peer-to-peer loan program.
// One block per loan (per originating transaction), not merged across loans
// that happen to share a payee. Principal/Interest are always calculated via
// getPayments() (same engine as everywhere else in the app, including its
// debt-assumption/vintages splits) -- this table never reads the ledger.
//
// Loans originated before JM Search's own March 2019 switch from annual to
// quarterly payments (see jms-payments.js's "switch from quarterly to annual
// payments" branch) get one row per YEAR for their pre-2019 span, then one row
// per quarter after that -- matching how those payments actually happened,
// rather than forcing a uniform 40 quarterly rows that were never paid that way.
//
// Per Chris's direction (2026-09-05): DynamoDB doesn't intentionally separate
// this user's individual payment streams -- it's one running ledger per
// direction (Payables / Receivables), not one per loan. So this report cross-
// checks totals only: at the bottom of each sheet, every quarter's SUM of this
// user's calculated payments (across every loan above) is compared against
// Nth Round's one recorded total for that same quarter. It does not attempt to
// attribute the ledger back to an individual loan row.
//
// Known engine limitation (see jms-payments.js:301, `if (ppmt != 0 && ipmt != 0)`):
// a loan's true final quarter, when the remaining balance is a principal-only
// payoff (int == 0 that quarter), is silently dropped by getPayments() itself.
// Per Chris's direction (2026-09-05), jms-payments.js is not being touched right
// now, so that one quarter, when it happens, is filled in here from the loan's
// own remaining balance (original PV minus every other period's principal
// getPayments() already returned) -- still a calculated number, not a ledger
// lookup, just derived locally instead of duplicating the engine's internal
// amortization branches.
//
// The functions below (through reconcileTotals) used to live as closures
// inside generatePaymentStatement itself, capturing eventUser/holderShares
// from its arguments. Lifted to module scope and parameterized instead, so
// computePaymentReconciliation (the payment scanner's per-holder pass, no
// ExcelJS/DOM involved) can call the exact same math and get numbers
// guaranteed to match what this file's own Excel report would show.

// JM Search's own cutover from annual to quarterly payments (see
// jms-payments.js: `if (eventStamp < 1551398400) { ppmt *= 4; ... }`).
const ANNUAL_CUTOVER_UNIX = 1551398400; // March 1, 2019

// This user's own recorded schedule for this direction -- one combined
// running ledger, not split per loan. Used only for the totals-only
// reconciliation, never for the calculated columns.
function getRealSchedule(eventClass, holderShares) {
	const bucketName = eventClass === 'NP' ? 'Payables' : 'Receivables';
	if (!holderShares) return null;
	for (const key of Object.keys(holderShares)) {
		const vesting = holderShares[key] && holderShares[key].vesting;
		if (vesting && vesting[bucketName] && vesting[bucketName].schedule) return vesting[bucketName].schedule;
	}
	return null;
}

function buildRealIndex(schedule) {
	if (!schedule) return [];
	return Object.entries(schedule).map(([stamp, entry]) => ({
		stamp: Number(stamp),
		amount: Number(entry.amount) || 0,
		posted: !!entry.posted,
	}));
}

// Archeology: these 2013-2014 grants were paid as a single lump sum or three
// uneven annual installments, not any amortization model getPayments() knows --
// no formula reproduces them, so getPayments() skips them entirely and this
// report generator hand-crafts their rows itself, straight from JM Search's own
// historical tracking spreadsheet (Equity Tracking Master), one payment per year
// starting the year after the grant. Campbell's has only one entry: the
// spreadsheet's own note reads "Only Purchased 1/2" and shows the full amount
// paid in year one.
const KNOWN_IRREGULAR_PAYMENTS = {
	'e3d1c842-c8bb-11eb-ad2e-4a805c513adc': [13095], // Marshall -> Pressman, 4286sh, Lump Sum
	'10af49de-c8bc-11eb-ad2e-4a805c513adc': [85639], // Marshall -> Pressman, 6640sh, Lump Sum
	'9699c77c-c8c1-11eb-aa47-aa75c12cef45': [13095], // Marshall -> Egoville, 4286sh, Lump Sum
	'640aae8a-c8bb-11eb-ad2e-4a805c513adc': [3435.3, 1743.93, 1743.93], // Sargent -> Pressman, 347sh
	'2babd2de-c8bc-11eb-ad2e-4a805c513adc': [3445.2, 1748.96, 1748.96], // Marshall -> Pressman, 348sh
	'462fbd8c-c8bc-11eb-ad2e-4a805c513adc': [54994.5, 27917.96, 27917.96], // Hildebrand -> Pressman, 5555sh
	'73ce6226-c8c0-11eb-aa47-aa75c12cef45': [53628.3, 27224.406495, 27224.406495], // Sargent -> Figueroa, 5417sh
	'e521caba-c8c2-11eb-aa47-aa75c12cef45': [16503.3, 8377.900245, 8377.900245], // Sargent -> McGinley, 1667sh
	'b0612b28-c8c6-11eb-8837-1a17dd1e4e59': [41253.3, 20942.237745, 20942.237745], // Hildebrand -> Tewell, 4167sh
	'944e0dc4-c8c7-11eb-8837-1a17dd1e4e59': [20631.6], // Hildebrand -> Campbell, 1042sh
	'ad51d340-c8c8-11eb-8837-1a17dd1e4e59': [20621.7, 10310.85, 10310.85], // Marshall -> Henry, 2083sh
	'466eccd0-c8c0-11eb-aa47-aa75c12cef45': [13095], // Marshall -> Figueroa, 4286sh
	'5aba1172-c8c0-11eb-aa47-aa75c12cef45': [63164], // Marshall -> Figueroa, 4890sh
	'98dffc12-c8c2-11eb-aa47-aa75c12cef45': [13095], // Marshall -> McGinley, 4286sh
	'8736a74c-c8c5-11eb-8837-1a17dd1e4e59': [13095], // Marshall -> Tewell, 4286sh
	'9e4f5c26-c8c5-11eb-8837-1a17dd1e4e59': [24165], // Marshall -> Tewell, 1870sh
	'56bf952c-c8c7-11eb-8837-1a17dd1e4e59': [13095], // Marshall -> Campbell, 4285sh
	'670ff76e-c8c7-11eb-8837-1a17dd1e4e59': [11257], // Marshall -> Campbell, 870sh
	'8a763ea6-c8c8-11eb-8837-1a17dd1e4e59': [13095], // Marshall -> Henry, 4285sh
	'7ed8764a-c8c8-11eb-8837-1a17dd1e4e59': [13373], // Marshall -> Henry, 1040sh
	'b1e32ea4-c1cd-11ed-b6dc-5ad408f8d356': [24777, 7443], // Marshall -> Schottland, 30k@$4 (2010) -- only 2 real payments before the 2013 settlement
};

// Periods getPayments() intentionally skips because jms-payments.js already folded them
// into an earlier lump-sum row (see its per-receiver prepayment-consolidation hacks) --
// not a real gap, so buildLoanRows() below should label them Prepaid, not flag them.
// KNOWN_IRREGULAR_PAYMENTS always renders one blended annual lump per year, which is wrong
// once a loan crosses into the quarterly-reporting era (confirmed against the reconciliation
// section: an annual lump there overshoots the recorded quarterly cash flow by thousands).
// This map overrides one specific report ROW (by its own period number) with a fixed total,
// bypassing getPayments() for exactly that period -- everything else about the loan, including
// every other period, is untouched. nrid -> { period (1-40) -> total dollar amount for that row }
const KNOWN_PAYMENT_ADJUSTMENTS = {
	// Marshall -> Campbell, 10000sh: getPayments() computes this loan correctly except for a
	// documented year-1 side arrangement per the legacy workbook ($9,466.725 instead of the
	// cohort's normal $14,839.45/yr).
	'3c0c79ca-c8c7-11eb-8837-1a17dd1e4e59': { 4: 9466.725 },
	// Hildebrand -> Campbell, 10000sh: no Valuations match for this transaction's sharePrice,
	// so getPayments() never sees it at all (#5621). Figures are this loan's same-cohort
	// sibling's (3c0c79ca, which does have a valid reference price) own validated schedule --
	// annual through year 7 (pre-quarterly-era), quarterly for years 8-10 to match how the
	// sibling (and the recorded reconciliation data) actually pays out those years.
	'331faa44-c8c7-11eb-8837-1a17dd1e4e59': {
		4: 14839.45,
		8: 14839.45,
		12: 14839.45,
		16: 14839.45,
		20: 14839.45,
		24: 14839.45,
		28: 14839.45,
		29: 3709.8625,
		30: 3709.8625,
		31: 3709.8625,
		32: 3709.8625,
		33: 3709.8625,
		34: 3709.8625,
		35: 3709.8625,
		36: 3709.8625,
		37: 2902.475,
		38: 2902.475,
		39: 2902.475,
		40: 2902.475,
	},
	// 2011-vintage 10,000sh tranche (Sargent/Hildebrand/Marshall, $11.19/sh): confirmed against
	// reconciliation -- the reduced year-1 payment isn't smaller in place, it's deferred whole
	// into the next January on top of that year's standard amount (period 4 = $0, period 8 =
	// standard $12,239.17 + deferred $6,408.545).
	'157bc952-c8bb-11eb-ad2e-4a805c513adc': { 4: 0, 8: 18647.715 }, // Sargent -> Pressman
	'26a0b3fa-c8c0-11eb-aa47-aa75c12cef45': { 4: 0, 8: 18647.715 }, // Marshall -> Figueroa
	'6f8dae32-c8c1-11eb-aa47-aa75c12cef45': { 4: 0, 8: 18647.715 }, // Sargent -> Egoville
	'68495882-c8c2-11eb-aa47-aa75c12cef45': { 4: 0, 8: 18647.715 }, // Hildebrand -> McGinley
	'555e4324-c8c5-11eb-8837-1a17dd1e4e59': { 4: 0, 8: 18647.715 }, // Hildebrand -> Tewell
	// Same tranche, split 3-ways to Henry (Marshall 3,334sh + Sargent 3,333sh + Hildebrand
	// 3,333sh = 10,000sh); deferral split evenly to match getPayments()'s own qty=3334 rounding
	// fudge above, which already treats all three sub-loans as identical.
	'323eb1f0-c8c8-11eb-8837-1a17dd1e4e59': { 4: 0, 8: 6216.720945 }, // Marshall -> Henry
	'3cc8efe6-c8c8-11eb-8837-1a17dd1e4e59': { 4: 0, 8: 6216.720945 }, // Sargent -> Henry
	'43c04ff6-c8c8-11eb-8837-1a17dd1e4e59': { 4: 0, 8: 6216.720945 }, // Hildebrand -> Henry
};

KNOWN_IRREGULAR_PAYMENTS['ce84e3b8-c1cd-11ed-b6dc-5ad408f8d356'] = []; // Marshall -> Schottland, 10k@$11.19 (2011) -- never paid; see one-off branch below
KNOWN_IRREGULAR_PAYMENTS['0edd3f0a-c1ce-11ed-b6dc-5ad408f8d356'] = []; // Marshall -> Schottland, 10k@$13.57 (2012) -- never paid; see one-off branch below

const KNOWN_PREPAID_PERIODS = {
	'abb50e98-c8c9-11eb-8837-1a17dd1e4e59': [38, 39, 40], // Marshall -> Hanzsche, 10000sh, paid in full at period 37
	'8c60b0da-c8c7-11eb-8837-1a17dd1e4e59': [37, 38, 39, 40], // Hildebrand -> Campbell, 15000sh, paid in full at period 36
};

// When a loan's own notes spell out exactly how its remaining balance was split among
// buyers (e.g. "Transfer (MB-2500, RG-2500, ...)"), parseAssumedPayers() below resolves
// each token against this holder's own outbound transactions -- see there, and
// buildLoanRows() below it, for how the period the assumption takes effect is derived
// from those transactions' own dates using the same 60-day-lag convention getPayments()'s
// debt-assumption handling already uses (jms-payments.js). No per-loan lookup table needed.

// Resolves the initials in a "(A-Qty, B-Qty, ...)" note against this holder's own outbound
// JMS transactions, using the same getInitials() convention the assumption engine in
// jms-payments.js already keys off of. Returns [] (falling back to normal gap handling)
// unless every token resolves and the quantities add up to the loan's own -- a mismatch
// means this note isn't the simple split this override assumes.
function parseAssumedPayers(t, eventUser) {
	const match = t.notes.match(/\(([^)]+)\)/);
	if (!match) return [];
	const outbound = clientData.equity['JMS'].transactions.filter((o) => o.sender === eventUser);
	// A note that re-assigns a share of an already-assumed earlier vintage prefixes the
	// payer list with that origin tag ("<origin initials> <year>: A-Qty, ...") -- the same
	// convention getPayments()'s own debt-assumption matching in jms-payments.js already
	// unwraps before reading the payer list, so mirror it here rather than let the two
	// silently disagree again on what the note means.
	let payerList = match[1];
	if (payerList.includes(':')) payerList = payerList.split(':')[1].trim();
	// A buyer who has assumed more than one of this holder's loans shows up more than once
	// in `outbound` -- disambiguate by requiring the transfer's own notes to reference THIS
	// loan's own vintage tag, the same "<lender initials> <year>" convention the debt-
	// assumption engine in jms-payments.js already keys its vintage matching off of. This
	// also protects against a plain initials match landing on a transfer for a different
	// loan entirely when there's only one candidate but it's the wrong one.
	const vintageTag = `${getInitials(t.senderName, clientData?.initials_overrides)} ${moment.unix(Number(t.date)).year()}`;
	const payers = payerList
		.split(',')
		.map((tok) => tok.trim())
		.map((tok) => {
			const [initials, qty] = tok.split('-');
			const o = outbound.find((c) => getInitials(c.receiverName, clientData?.initials_overrides) === initials.trim() && c.notes.includes(vintageTag));
			return o ? { name: o.receiverName, qty: parseInt(qty, 10), date: Number(o.date) } : null;
		});
	if (payers.some((p) => !p)) return [];
	return payers.reduce((s, p) => s + p.qty, 0) === Number(t.quantity) ? payers : [];
}

// This user's own loan-originating transactions for a direction -- same
// filters getPayments() itself applies (reference-price match, excluding
// the manual "Lump Sum"/"Three Payments" marker transactions, and direction) --
// plus the archeology loans above, which getPayments() never sees.
function getLoanTransactions(eventClass, eventUser) {
	const allTx = clientData.equity['JMS'].transactions;
	const referenceVals = clientData.equity['JMS'].valuations;
	let tx = allTx.filter((t) => {
		if (KNOWN_IRREGULAR_PAYMENTS[t.nrid] || KNOWN_PAYMENT_ADJUSTMENTS[t.nrid]) return true;
		const refVal = referenceVals.find((v) => Number(v.sharePrice) == Number(t.sharePrice) && Number(v.date) <= Number(t.date) + 2 * 86400);
		return !!refVal;
	});
	tx = tx.filter(
		(t) => KNOWN_IRREGULAR_PAYMENTS[t.nrid] || KNOWN_PAYMENT_ADJUSTMENTS[t.nrid] || !['Lump Sum', 'Three Payments'].some((s) => t.notes.includes(s))
	);
	tx = tx.filter((t) => (eventClass === 'NP' ? t.receiver === eventUser : t.sender === eventUser));
	return tx.slice().sort((a, b) => Number(a.date) - Number(b.date));
}

// The complete quarterly (or, pre-2019, annual) schedule for one loan,
// querying getPayments() at each of that loan's own anchors and keeping only
// the entries that are this loan's own remaining-balance payment, plus (if
// this loan's notes carry a vintages tag) whatever gets assumed on its
// behalf during that window.
function buildLoanRows(t, eventClass, vintages, eventUser) {
	const startUnix = Number(t.date);
	const expectedUid = eventClass === 'NR' ? t.receiver : t.sender;
	const hasVintageTag = Object.keys(vintages).some((v) => t.notes.includes(v)) || Object.values(vintages).some((arr) => arr.some((x) => t.notes.includes(x)));
	const irregular = KNOWN_IRREGULAR_PAYMENTS[t.nrid];
	const prepaidPeriods = KNOWN_PREPAID_PERIODS[t.nrid] || [];

	if (['ce84e3b8-c1cd-11ed-b6dc-5ad408f8d356', '0edd3f0a-c1ce-11ed-b6dc-5ad408f8d356'].includes(t.nrid)) {
		return [
			{
				period: '1-40',
				stamp: moment('2013-05-06').unix(),
				isAnnualEra: true,
				name: `${String((eventClass === 'NR' ? t.receiverName : t.senderName) || 'Unknown')} -- never paid (2013 settlement)`,
				principal: 0,
				interest: 0,
				derived: false,
			},
		];
	}

	const assumedPayers = parseAssumedPayers(t, eventUser);
	let assumedRate, assumedPv, assumedFinance, assumedFromPeriod;
	if (assumedPayers.length) {
		assumedPv = Number(t.sharePrice) * Number(t.quantity);
		const assumedGross = Number(t.referencePrice) * Number(t.quantity);
		assumedFinance = new Finance();
		assumedRate = assumedFinance.RATE(40, -(assumedGross / 40), assumedPv);

		// The assumption takes effect the first quarter more than 60 days after the
		// buyers' own transfer date(s) -- same lag convention getPayments()'s debt-
		// assumption handling uses (jms-payments.js). Use the latest of the matched
		// transfer dates so a loan isn't marked assumed before every payer has joined.
		const lastTransferDate = Math.max(...assumedPayers.map((p) => p.date));
		for (let i = 1; i <= 40; i++) {
			const stampI = moment
				.unix(startUnix)
				.add(3 * i, 'months')
				.unix();
			if (lastTransferDate < stampI - 60 * 24 * 3600) {
				assumedFromPeriod = i;
				break;
			}
		}
	}

	const rows = [];
	for (let i = 1; i <= 40; i++) {
		const stamp = moment
			.unix(startUnix)
			.add(3 * i, 'months')
			.unix();
		// Pre-cutover quarters were serviced with one annual payment covering
		// all 4 of them (see jms-payments.js's own quarterly/annual switch) --
		// wait for the year-end anchor (i % 4 === 0) rather than querying, and
		// creating a row for, each of the 3 quarters in between.
		const isAnnualEra = stamp < ANNUAL_CUTOVER_UNIX;
		if (isAnnualEra && i % 4 !== 0) continue;

		const periodOverride = KNOWN_PAYMENT_ADJUSTMENTS[t.nrid]?.[i];
		if (periodOverride !== undefined) {
			rows.push({
				period: isAnnualEra ? `${i - 3}-${i}` : i,
				stamp,
				isAnnualEra,
				name: String((eventClass === 'NR' ? t.receiverName : t.senderName) || 'Unknown'),
				principal: periodOverride,
				interest: 0, // one substituted total, not a principal/interest split
				derived: false,
				adjusted: true,
			});
			continue;
		}

		// Archeology loan: skip getPayments() entirely, place its known amount at
		// the matching year and stop -- no row (gap or otherwise) beyond its own
		// known length, since these loans genuinely end there.
		if (irregular) {
			const amount = irregular[i / 4 - 1];
			if (amount) {
				rows.push({
					period: `${i - 3}-${i}`,
					stamp,
					isAnnualEra,
					name: String((eventClass === 'NR' ? t.receiverName : t.senderName) || 'Unknown'),
					principal: amount,
					interest: 0, // spreadsheet gives one blended figure, not a principal/interest split
					derived: false,
				});
			}
			continue;
		}

		// Known buyer-assumed payoff: this loan's own share of its original amortization,
		// scaled to each buyer's assumed quantity, starting the period derived above from
		// the buyers' own transfer dates.
		if (assumedPayers.length && i >= assumedFromPeriod) {
			const qtyFull = Number(t.quantity);
			const ppmtFull = -assumedFinance.PPMT(assumedRate, i, 40, assumedPv);
			const ipmtFull = -assumedFinance.IPMT(assumedRate, i, 40, assumedPv);
			rows.push({
				period: isAnnualEra ? `${i - 3}-${i}` : i,
				stamp,
				isAnnualEra,
				name:
					'Assumed by ' +
					assumedPayers.map((p) => `${getInitials(p.name, clientData?.initials_overrides)} (${Math.round((p.qty / qtyFull) * 100)}%)`).join(', '),
				principal: assumedPayers.reduce((s, p) => s + (ppmtFull * p.qty) / qtyFull, 0),
				interest: assumedPayers.reduce((s, p) => s + (ipmtFull * p.qty) / qtyFull, 0),
				derived: false,
				assumed: true,
			});
			continue;
		}

		let payments = [];
		try {
			payments = getPayments(eventUser, eventClass, stamp) || [];
		} catch (err) {
			console.error('generatePaymentStatement: getPayments failed for', eventClass, 'period', i, err);
		}

		// In the annual era getPayments() returns period as a string range
		// (e.g. "1-4"), not a plain number -- match this loan's own entry by
		// that range's upper bound instead of by numeric equality. This only
		// applies to this loan's OWN entry: an assumed-from entry's period is
		// expressed in the assumed-from loan's own numbering (e.g. periods
		// 33-40 of a 2014 loan), not this loan's i, so it's matched by name
		// and uid, never by period.
		const periodMatches = (p) => (isAnnualEra ? String(p.period).split('-').pop() == i : Math.abs(Number(p.period) - i) < 0.4);
		// originNrid also required: getPayments() computes all of this holder's loans in one
		// pass, so uid/name/period alone can't tell which loan a record belongs to -- without
		// this, a holder with two loans to the same person (or two loans sharing one vintage's
		// assumption pool) got the same record double-counted into both loans' rows.
		const ownEntries = payments.filter((p) => p.uid === expectedUid && p.originNrid === t.nrid && periodMatches(p));
		const assumedEntries = hasVintageTag
			? payments.filter((p) => String(p.name).includes('(assumed from') && p.uid !== expectedUid && p.originNrid === t.nrid)
			: [];
		const matches = [...ownEntries, ...assumedEntries];

		// One row per period, always -- if this loan's payment is split across
		// more than one payee this quarter (a debt-assumption chain running
		// concurrently with the remaining balance), combine them into a single
		// row rather than multiplying this loan's row count.
		if (matches.length) {
			rows.push({
				period: isAnnualEra ? `${i - 3}-${i}` : i,
				stamp,
				isAnnualEra,
				name: matches.map((p) => String(p.name || 'Unknown').replace(/<br\s*\/?>/gi, ' ')).join(' + '),
				principal: matches.reduce((sum, p) => sum + (Number(p.prin) || 0), 0),
				interest: matches.reduce((sum, p) => sum + (Number(p.int) || 0), 0),
				derived: false,
			});
		} else {
			rows.push({ period: isAnnualEra ? `${i - 3}-${i}` : i, stamp, isAnnualEra, name: null, principal: null, interest: null, derived: true });
		}
	}

	const gaps = rows.filter((r) => r.derived);
	if (gaps.length) {
		const qty = Number(t.quantity);
		const pv = Number(t.sharePrice) * qty;
		let remaining = pv;
		rows.forEach((r) => {
			if (!r.derived) remaining -= r.principal;
		});
		// A loan already fully accounted for by its real payments (remaining ~$0) was
		// paid off ahead of the nominal 40-quarter schedule -- nothing is missing, so
		// drop the placeholder rows instead of flagging them red/yellow.
		if (Math.abs(remaining) < 1) return rows.filter((r) => !r.derived);
		const fallbackName = (rows.find((r) => !r.derived) || {}).name || String(t.senderName || t.receiverName || 'Unknown');
		gaps.forEach((r, idx) => {
			const period = Number(String(r.period).split('-').pop());
			if (prepaidPeriods.includes(period)) {
				r.name = 'Prepaid';
				r.principal = 0;
				r.interest = 0;
				r.prepaid = true;
				r.unexpectedGap = false;
				return;
			}
			r.name = fallbackName;
			// Only the loan's true last row is expected to be missing (the known
			// engine limitation above); anything else missing is unexpected, so
			// it's zeroed rather than guessed at, and flagged for a human to check.
			const isTrailingGap = idx === gaps.length - 1 && r === rows[rows.length - 1];
			r.principal = isTrailingGap ? remaining : 0;
			r.interest = 0;
			r.unexpectedGap = !isTrailingGap;
			if (r.unexpectedGap) console.error('generatePaymentStatement: unexpected gap at period', r.period, 'for transaction', t);
		});
	}
	return rows;
}

// Whether one of buildLoanRows()'s rows belongs in a comparison against this
// holder's own real ledger -- shared by generatePaymentStatement's own
// reconciliation section and by computePaymentReconciliation (the payment
// scanner) below, so the two can never again silently disagree about what
// counts as this holder's own expected payment. A gap row (derived) isn't a
// real payment yet; an assumed-payoff row is paid directly to the original
// lender by the buyer who assumed it, so it never lands on this holder's own
// real ledger either -- see the "Assumed" row styling/note above.
function isOwnExpectedRow(r) {
	return !r.derived && !r.assumed;
}

// Totals-only reconciliation: cluster every calculated row and every real
// ledger entry by calendar proximity (quarters are ~90 days apart, so a
// 20-day window can't bleed into a neighboring quarter), then compare the
// SUMS within each cluster. This is deliberately not a per-loan match --
// DynamoDB keeps one running ledger per direction, not one per loan, so
// summing everything that lands in the same quarter is the only comparison
// the data actually supports.
function reconcileTotals(calcItems, realIndex, windowDays) {
	const windowSec = windowDays * 24 * 3600;
	const all = calcItems
		.map((x) => ({ kind: 'calc', stamp: x.stamp, amount: x.total, principal: x.principal, interest: x.interest }))
		.concat(realIndex.map((x) => ({ kind: 'real', stamp: x.stamp, amount: x.amount })))
		.sort((a, b) => a.stamp - b.stamp);

	const clusters = [];
	let current = [];
	all.forEach((item) => {
		if (current.length && item.stamp - current[current.length - 1].stamp > windowSec) {
			clusters.push(current);
			current = [];
		}
		current.push(item);
	});
	if (current.length) clusters.push(current);

	return clusters
		.map((cluster) => {
			const calc = cluster.filter((x) => x.kind === 'calc');
			const real = cluster.filter((x) => x.kind === 'real');
			const calcSum = calc.reduce((s, x) => s + x.amount, 0);
			const calcPrincipal = calc.reduce((s, x) => s + (x.principal || 0), 0);
			const calcInterest = calc.reduce((s, x) => s + (x.interest || 0), 0);
			const realSum = real.reduce((s, x) => s + x.amount, 0);
			// Prefer the real entry's own date (that's the date actually on Nth
			// Round's books) as the row's label; fall back to the calculated
			// date when nothing real landed in this cluster yet.
			const stamp = real.length ? real[0].stamp : calc[0].stamp;
			return { stamp, calcCount: calc.length, realCount: real.length, calcSum, calcPrincipal, calcInterest, realSum, diff: calcSum - realSum };
		})
		.filter((c) => c.calcCount > 0);
}

// Pure computation (no ExcelJS, no DOM) of one holder's payment reconciliation
// across both directions -- the payment scanner's per-holder pass. Reuses the
// exact same helpers as generatePaymentStatement below, so a holder this
// flags can be handed the single-holder report and show the identical numbers.
export function computePaymentReconciliation(eventUser, holderShares) {
	const result = {};
	['NP', 'NR'].forEach((eventClass) => {
		const vintages = clientData.equity['JMS'].vintages;
		const loanTransactions = getLoanTransactions(eventClass, eventUser);
		const realIndex = buildRealIndex(getRealSchedule(eventClass, holderShares));

		const allCalcItems = [];
		let unexpectedGaps = 0;
		loanTransactions.forEach((t) => {
			const rows = buildLoanRows(t, eventClass, vintages, eventUser);
			rows.forEach((r) => {
				if (r.unexpectedGap) unexpectedGaps++;
				if (isOwnExpectedRow(r)) allCalcItems.push({ stamp: r.stamp, total: r.principal + r.interest });
			});
		});

		const recon = reconcileTotals(allCalcItems, realIndex, 20);
		const matched = recon.filter((c) => c.realCount);

		result[eventClass] = {
			loanCount: loanTransactions.length,
			totalCalculated: recon.reduce((s, c) => s + c.calcSum, 0),
			totalReal: matched.reduce((s, c) => s + c.realSum, 0),
			netDiff: matched.reduce((s, c) => s + c.diff, 0),
			absDiffSum: matched.reduce((s, c) => s + Math.abs(c.diff), 0),
			badQuarterCount: matched.filter((c) => Math.abs(c.diff) > 1).length,
			matchedQuarterCount: matched.length,
			unexpectedGaps,
		};
	});
	return result;
}

export async function generatePaymentStatement(transactions, eventUser, displayName, holderShares) {
	if (!window.ExcelJS) {
		try {
			await window.loadExcelJS();
		} catch (err) {
			console.error('ExcelJS loading failed:', err);
			M.toast({ html: 'Failed to load Excel export library. Please try again.' });
			return;
		}
	}

	const HEADER_FILL = 'FF1F3864';
	const HEADER_FONT = 'FFFFFFFF';
	const LOAN_FILL = 'FF2E5395';
	const LOAN_FONT = 'FFFFFFFF';
	const SUBTOTAL_FILL = 'FFD9E1F2';
	const GRAND_FILL = 'FFBDD7EE';
	const BAND_FILL = 'FFF7F9FC';
	const FLAG_FILL = 'FFFFF2CC';
	const FLAG_FONT = 'FF9C5700';
	const RECON_HEADER_FILL = 'FF3B5170';
	const RECON_BAD_FILL = 'FFFFC7CE';
	const RECON_BAD_FONT = 'FF9C0006';
	const ASSUMED_FILL = 'FFDCE6F1';
	const ASSUMED_FONT = 'FF1F3864';
	const PREPAID_FILL = 'FFE2EFDA';
	const PREPAID_FONT = 'FF375623';
	const N_COLS = 7; // #, Quarter, Payee, Principal, Interest, Total, Status
	// "Per Nth Round (actual)" / "Diff" compare this holder's calculated totals against Nth
	// Round's own recorded ledger -- back-office context a non-admin shareholder shouldn't see.
	const showNthAdminCols = typeof nthAdmin !== 'undefined' && nthAdmin;

	function buildClassSheet(workbook, eventClass) {
		// Skip this tab entirely rather than publish an empty placeholder -- most
		// holders only have activity in one direction.
		const loanTransactions = getLoanTransactions(eventClass, eventUser);
		if (!loanTransactions.length) return;

		const sheet = workbook.addWorksheet(eventClass === 'NP' ? 'Payables' : 'Receivables');
		const vintages = clientData.equity['JMS'].vintages;
		const realIndex = buildRealIndex(getRealSchedule(eventClass, holderShares));
		const nowUnix = moment().unix();

		sheet.addRow([`JM Search — Payment Statement — ${displayName}`]).font = { bold: true, size: 14 };
		sheet.addRow([eventClass === 'NP' ? 'Notes Payable' : 'Notes Receivable']).font = { italic: true, size: 10, color: { argb: 'FF555555' } };
		sheet.addRow([`Generated ${moment().format('M/D/YYYY')} — Principal/Interest are calculated via the app's existing getPayments() engine.`]).font = {
			italic: true,
			size: 10,
			color: { argb: 'FF555555' },
		};
		sheet.addRow(['Click the + buttons in the row gutter to expand a loan to its Subtotal line.']).font = {
			italic: true,
			size: 10,
			color: { argb: 'FF555555' },
		};
		sheet.addRow([]);

		const headerRow = sheet.addRow(['#', 'Quarter', 'Principal', 'Interest', 'Total Payment', 'Payee', 'Status']);
		headerRow.eachCell((cell) => {
			cell.font = { bold: true, color: { argb: HEADER_FONT } };
			cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: HEADER_FILL } };
			cell.alignment = { horizontal: 'center', wrapText: true };
		});

		const subtotalRowNumbers = [];
		const allCalcItems = []; // flat, across every loan in this class -- feeds the combined reconciliation below

		loanTransactions.forEach((t) => {
			const rows = buildLoanRows(t, eventClass, vintages, eventUser);

			const loanLabel = `${(eventClass === 'NR' ? t.receiverName : t.senderName) || 'Unknown'} — originated ${moment
				.unix(Number(t.date))
				.format('MMM YYYY')} — ${Number(t.quantity).toLocaleString()} shares`;
			const groupHeaderRow = sheet.addRow([loanLabel]);
			sheet.mergeCells(groupHeaderRow.number, 1, groupHeaderRow.number, N_COLS);
			groupHeaderRow.getCell(1).font = { bold: true, color: { argb: LOAN_FONT } };
			groupHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: LOAN_FILL } };

			const firstDetailRow = groupHeaderRow.number + 1;
			rows.forEach((r, i) => {
				const total = r.principal + r.interest;
				const row = sheet.addRow([
					r.period,
					moment.unix(r.stamp).format('MMM-YY'),
					r.principal,
					r.interest,
					{ formula: `C${firstDetailRow + i}+D${firstDetailRow + i}` },
					r.name,
					r.stamp <= nowUnix ? 'Paid' : 'Scheduled',
				]);
				row.outlineLevel = 1;
				row.hidden = true; // start collapsed -- gutter shows "+" until expanded
				row.eachCell((cell) => (cell.alignment = { horizontal: 'center' }));
				['C', 'D', 'E'].forEach((col) => (row.getCell(col).numFmt = '$#,##0.00;($#,##0.00);"-"'));
				if (r.isAnnualEra) row.getCell(2).font = { italic: true };
				if (i % 2 === 1) row.eachCell((cell) => (cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: BAND_FILL } }));

				if (r.prepaid) {
					row.eachCell((cell) => {
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: PREPAID_FILL } };
						cell.font = { color: { argb: PREPAID_FONT }, italic: true };
					});
					row.getCell(3).note = {
						texts: [{ text: 'Folded into an earlier lump-sum payment on this loan -- see KNOWN_PREPAID_PERIODS.' }],
					};
				} else if (r.derived && !r.unexpectedGap) {
					row.eachCell((cell) => {
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: FLAG_FILL } };
						cell.font = { color: { argb: FLAG_FONT }, italic: true };
					});
					row.getCell(3).note = {
						texts: [
							{
								text:
									'Derived from this loan’s remaining balance, not returned by getPayments(): a known engine limitation ' +
									'silently drops a loan’s true final quarter when it is a principal-only payoff (interest == 0 that quarter). ' +
									'See jms-payments.js line ~301.',
							},
						],
					};
				} else if (r.assumed) {
					row.eachCell((cell) => {
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: ASSUMED_FILL } };
						cell.font = { color: { argb: ASSUMED_FONT }, italic: true };
					});
					row.getCell(6).alignment = { horizontal: 'left' };
					row.getCell(6).note = {
						texts: [
							{ text: 'Paid directly to the original lender by the buyer(s) who assumed this loan, per its own transaction notes -- not a gap.' },
						],
					};
				} else if (r.unexpectedGap) {
					row.eachCell((cell) => {
						cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC7CE' } };
						cell.font = { color: { argb: 'FF9C0006' }, italic: true };
					});
					row.getCell(3).note = {
						texts: [{ text: 'getPayments() returned nothing for this quarter and it is not the loan’s final quarter -- needs a look.' }],
					};
				}
				if (/assumed/i.test(String(r.name || ''))) row.getCell(6).alignment = { horizontal: 'left' };

				// Assumed-payoff rows are informational only -- the buyer pays the original
				// lender directly, so nothing lands on this holder's own real ledger for them.
				if (isOwnExpectedRow(r)) allCalcItems.push({ stamp: r.stamp, total, principal: r.principal, interest: r.interest });
			});
			const lastDetailRow = firstDetailRow + rows.length - 1;

			const subtotalRow = sheet.addRow([
				'Subtotal',
				null,
				{ formula: `SUM(C${firstDetailRow}:C${lastDetailRow})` },
				{ formula: `SUM(D${firstDetailRow}:D${lastDetailRow})` },
				{ formula: `SUM(E${firstDetailRow}:E${lastDetailRow})` },
				null,
				null,
			]);
			sheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, 2);
			subtotalRow.eachCell((cell) => {
				cell.font = { bold: true };
				cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: SUBTOTAL_FILL } };
				cell.alignment = { horizontal: 'center' };
			});
			['C', 'D', 'E'].forEach((col) => (subtotalRow.getCell(col).numFmt = '$#,##0.00;($#,##0.00);"-"'));
			subtotalRowNumbers.push(subtotalRow.number);
			sheet.addRow([]);
		});

		const grandRow = sheet.addRow([
			'GRAND TOTAL — all loans',
			null,
			{ formula: subtotalRowNumbers.map((r) => `C${r}`).join('+') || '0' },
			{ formula: subtotalRowNumbers.map((r) => `D${r}`).join('+') || '0' },
			{ formula: subtotalRowNumbers.map((r) => `E${r}`).join('+') || '0' },
			null,
			null,
		]);
		sheet.mergeCells(grandRow.number, 1, grandRow.number, 2);
		grandRow.eachCell((cell) => {
			cell.font = { bold: true };
			cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: GRAND_FILL } };
			cell.alignment = { horizontal: 'center' };
		});
		['C', 'D', 'E'].forEach((col) => (grandRow.getCell(col).numFmt = '$#,##0.00;($#,##0.00);"-"'));

		// Combined reconciliation -- see reconcileTotals() above for why this is
		// totals-only rather than per-loan.
		const recon = reconcileTotals(allCalcItems, realIndex, 20);
		if (recon.length) {
			sheet.addRow([]);

			const reconHeaderRow = sheet.addRow(
				showNthAdminCols
					? [null, 'Quarter', 'Principal', 'Interest', 'Calculated Total (all loans)', 'Per Nth Round (actual)', 'Diff']
					: [null, 'Quarter', 'Principal', 'Interest', 'Calculated Total (all loans)']
			);
			reconHeaderRow.eachCell((cell, col) => {
				if (col > N_COLS) return;
				cell.font = { bold: true, color: { argb: HEADER_FONT } };
				cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: RECON_HEADER_FILL } };
				cell.alignment = { horizontal: 'center', wrapText: true };
			});

			const reconFirstRow = reconHeaderRow.number + 1;
			recon.forEach((c, i) => {
				const r = reconFirstRow + i;
				const row = sheet.addRow(
					showNthAdminCols
						? [
								null,
								moment.unix(c.stamp).format('MMM-YY'),
								c.calcPrincipal,
								c.calcInterest,
								c.calcSum,
								c.realCount ? c.realSum : null,
								c.realCount ? { formula: `E${r}-F${r}` } : null,
							]
						: [null, moment.unix(c.stamp).format('MMM-YY'), c.calcPrincipal, c.calcInterest, c.calcSum]
				);
				(showNthAdminCols ? ['C', 'D', 'E', 'F', 'G'] : ['C', 'D', 'E']).forEach((col) => (row.getCell(col).numFmt = '$#,##0.00;($#,##0.00);"-"'));
				row.eachCell((cell) => (cell.alignment = { horizontal: 'center' }));
				if (i % 2 === 1)
					row.eachCell((cell, col) => {
						if (col <= N_COLS) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: BAND_FILL } };
					});
				if (showNthAdminCols) {
					if (!c.realCount) {
						row.getCell(6).value = 'not yet on Nth Round’s schedule';
						row.getCell(6).font = { italic: true, size: 10, color: { argb: 'FF555555' } };
					} else if (Math.abs(c.diff) > 1) {
						['B', 'C', 'D', 'E', 'F', 'G'].forEach((col) => {
							row.getCell(col).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: RECON_BAD_FILL } };
							row.getCell(col).font = { color: { argb: RECON_BAD_FONT } };
						});
					}
				}
			});
			const reconLastRow = reconFirstRow + recon.length - 1;

			if (showNthAdminCols) {
				sheet.addRow([]);
				const qaRow = sheet.addRow(['Check: every quarter’s combined total ties to Nth Round’s combined record within a dollar (Diff ≈ 0)?']);
				qaRow.getCell(1).font = { italic: true, size: 10, color: { argb: 'FF555555' } };
				qaRow.getCell(2).value = { formula: `SUMPRODUCT(--(ABS(G${reconFirstRow}:G${reconLastRow})>1))=0` };
				qaRow.getCell(2).font = { italic: true, size: 10, color: { argb: 'FF555555' } };
			}
		}

		sheet.getColumn(1).width = 6;
		sheet.getColumn(2).width = 10;
		sheet.getColumn(3).width = 15;
		sheet.getColumn(4).width = 13;
		sheet.getColumn(5).width = 15;
		sheet.getColumn(6).width = 26;
		sheet.getColumn(7).width = 11;
		sheet.views = [{ state: 'frozen', xSplit: 0, ySplit: headerRow.number }];
	}

	const workbook = new window.ExcelJS.Workbook();
	buildClassSheet(workbook, 'NR');
	buildClassSheet(workbook, 'NP');
	if (!workbook.worksheets.length) workbook.addWorksheet('Payment Statement').addRow(['No Notes Payable or Notes Receivable activity found for this user.']);

	const buffer = await workbook.xlsx.writeBuffer();
	const filename = `${displayName} JMS Payment Statement dated ${moment().format('YYYY-MM-DD')}.xlsx`;
	saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename);

	if (window.analytics)
		window.analytics.track('Generated JMS Payment Statement', {
			userEmail: authedUser,
			workspace: client,
			userId: eventUser,
		});
}
